"use client"

import { useState, useEffect } from "react"
import { supabase } from "../../supabaseClient"
import { useAuth } from "../../context/AuthContext"
import { applyInstitutionFilter } from "../../lib/tenant"
import "../../styles/SalaList.css"

export default function SalaList({ keyProp, onEdit }) {
  const { isAdmin, instituicaoId } = useAuth()
  const [salas, setSalas] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchSalas = async () => {
    setLoading(true)
    try {
      let query = supabase.from("salas").select("id, nome, capacidade, created_at").order("nome", { ascending: true })
      query = applyInstitutionFilter(query, isAdmin, instituicaoId)
      const { data, error } = await query
      if (error) throw error
      setSalas(data || [])
    } catch (err) {
      console.error("Erro ao buscar salas:", err.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSalas()
  }, [keyProp])

  const handleDelete = async (sala) => {
    if (!window.confirm(`Tem certeza que deseja excluir a sala "${sala.nome}"?`)) {
      return
    }

    try {
      let turmasQuery = supabase.from("turmas").select("id, nome").eq("sala_id", sala.id)
      turmasQuery = applyInstitutionFilter(turmasQuery, isAdmin, instituicaoId)
      const { data: turmasUsando } = await turmasQuery

      if (turmasUsando && turmasUsando.length > 0) {
        const confirmar = window.confirm(
          `Esta sala está sendo usada por ${turmasUsando.length} turma(s). Deseja remover a associação e excluir a sala?`,
        )
        if (!confirmar) return

        await supabase.from("turmas").update({ sala_id: null }).eq("sala_id", sala.id)
      }

      const { error } = await supabase.from("salas").delete().eq("id", sala.id)
      if (error) throw error

      fetchSalas()
    } catch (err) {
      console.error("Erro ao excluir sala:", err.message)
      alert("Erro ao excluir sala: " + err.message)
    }
  }

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Carregando salas...</p>
      </div>
    )
  }

  if (!salas.length) {
    return (
      <div className="empty-state">
        <p>Nenhuma sala cadastrada.</p>
      </div>
    )
  }

  return (
    <div className="sala-list-container">
      <h3 className="list-title">Salas Cadastradas</h3>

      <div className="salas-list">
        {salas.map((sala) => (
          <div key={sala.id} className="sala-card">
            <div className="card-header">
              <h3 className="sala-nome">{sala.nome}</h3>
              <span className="sala-capacidade">{sala.capacidade} lugares</span>
            </div>

            <div className="card-body">
              <div className="info-row">
                <span className="info-label">Criado em:</span>
                <span className="info-value">
                  {sala.created_at ? new Date(sala.created_at).toLocaleDateString("pt-BR") : "-"}
                </span>
              </div>
            </div>

            <div className="card-actions">
              <button className="btn-editar" onClick={() => onEdit && onEdit(sala)}>
                Editar
              </button>
              <button className="btn-excluir" onClick={() => handleDelete(sala)}>
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
